// ~~ Generated. This file cannot be edited directly. Please look at libs/nx-tooling/src/generators/backoffice-project/generator.ts

import { FleetMaintenanceAreaRoutes } from '@backoffice-frontend/fleet-maintenance-api'
import { SuspenseLoadingWrapper } from '@backoffice-frontend/patterns'
import { BoumRight } from '@moia-dev/moia-token-claims'
import { lazy } from 'react'
import { FleetMaintenanceAreaId } from './FleetMaintenanceAreaId'

import {
  FleetMaintenanceAreaNavigation,
  FleetMaintenanceAreaNavigationIcon,
} from './FleetMaintenanceAreaNavigation'

const LazyFleetMaintenanceComponent = lazy(
  () => import('./FleetMaintenanceArea'),
)

const FleetMaintenanceComponent = () => (
  <SuspenseLoadingWrapper>
    <LazyFleetMaintenanceComponent />
  </SuspenseLoadingWrapper>
)

export const FleetMaintenanceArea = {
  id: FleetMaintenanceAreaId,
  requiredRight: BoumRight.AREA_FLEET_MAINTENANCE,
  Icon: FleetMaintenanceAreaNavigationIcon,
  NavigationComponent: FleetMaintenanceAreaNavigation,
  route: {
    path: FleetMaintenanceAreaRoutes.route,
    component: FleetMaintenanceComponent,
  },
}
